import axios from 'axios'
import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.timeout = 10 * 1000

axios.interceptors.request.use(config => {
  // Do something before request is sent
  // 给所有请求添加自定义header
  const { sso_sessionid, appName } = store.state
  config.headers['sso_sessionid'] = sso_sessionid
  config.headers['appName'] = appName
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
axios.interceptors.response.use(response => {
  return response.data
}, error => {
  return Promise.reject(error)
})

export const ajax = {}


export default axios